import React from 'react';
import { ModalContainer } from '../../../../../shared/modal-container/ModalContainer';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { AddTeamModalContent } from './AddTeamModalContent';
import { addTeam } from '../redux/add-team/actions';

const handleAddTeam = (props, team) => {
    _.isFunction(props.addTeam) && props.addTeam(team);
    _.isFunction(props.forwardedRef.current.closeModal) &&
        props.forwardedRef.current.closeModal();
};

const AddTeamModal = props => (
    <ModalContainer
        content={
            <AddTeamModalContent addTeam={team => handleAddTeam(props, team)} />
        }
        title={'Add Team'}
        ref={props.forwardedRef}
    />
);

const mapDispatchToProps = dispatch => ({
    addTeam: team => dispatch(addTeam(team))
});

const ConnectedAddTeamModal = connect(null, mapDispatchToProps)(AddTeamModal);

export default React.forwardRef((props, ref) => (
    <ConnectedAddTeamModal {...props} forwardedRef={ref} />
));
